import React from 'react';
import { Box, CardContent, styled, Typography } from '@mui/material';
import { ReactComponent as DoctorOkSvg } from '../../../assets/doctor-ok.svg';

function Final() {
  return (
    <>
      <CardContentWrap sx={{ padding: '32px 0 48px', margin: '0 auto' }}>
        <Box className='card__image-wrap card__final-block'>
          <DoctorOkSvg className='card__image' style={{ width: '100%' }} />
        </Box>

        <Typography
          sx={{
            fontFamily: '"Nunito Sans", sans-serif',
          }}
          fontSize={20}
          lineHeight='24px'
          fontWeight={700}
        >
          Спасибо за сообщение!
        </Typography>

        <Typography
          sx={{
            fontFamily: '"Nunito Sans", sans-serif',
            mb: 2,
          }}
          fontSize={16}
          lineHeight='24px'
          fontWeight={400}
        >
          Мы вернемся к Вам с решением.
        </Typography>
      </CardContentWrap>
    </>
  );
}

const CardContentWrap = styled(CardContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
`;

export default Final;
